import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHeart, FiCompass, FiSun } = FiIcons;

export default function AboutCouple() {
  return (
    <section id="story" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-6">
              <img 
                src="/media/mentoring.jpeg"
                alt="Rosemary mentoring" 
                className="rounded-3xl shadow-xl mt-12 w-full object-cover aspect-[4/5]"
              />
              <img 
                src="/media/guiding.jpeg"
                alt="Pete guiding others" 
                className="rounded-3xl shadow-xl w-full object-cover aspect-[4/5]"
              />
            </div>
          </div>
          
          <div className="order-1 lg:order-2">
            <h2 className="text-[#005b2d] font-extrabold uppercase tracking-widest text-sm mb-4">Our Shared Heart</h2>
            <h3 className="text-4xl lg:text-5xl font-bold text-[#5E3A21] mb-6">Where the Love Grows</h3>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              As a recently married couple, we've united our lives and our life's work. Through our nonprofit, <span className="font-semibold text-[#005b2d]">Where the Love Grows</span>, we provide holistic healing for the broken. Together, we are a team dedicated to restoring lives.
            </p>
            
            <div className="space-y-10">
              <div className="flex gap-6">
                <div className="w-14 h-14 rounded-2xl bg-[#005b2d]/10 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiHeart} className="text-[#005b2d] text-2xl" />
                </div>
                <div>
                  <h4 className="font-bold text-[#5E3A21] text-xl mb-2">Rosemary's Personal Mission</h4>
                  <p className="text-slate-600 leading-relaxed">
                    Rosemary mentors mothers who have lost their children to drugs and unhealthy lifestyles, offering a beacon of hope and a sisterhood of healing through the deepest grief.
                  </p>
                </div>
              </div>

              <div className="flex gap-6">
                <div className="w-14 h-14 rounded-2xl bg-[#005b2d]/10 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiCompass} className="text-[#005b2d] text-2xl" />
                </div>
                <div>
                  <h4 className="font-bold text-[#5E3A21] text-xl mb-2">Pete's Personal Mission</h4>
                  <p className="text-slate-600 leading-relaxed">
                    Pete guides individuals toward physical, mental, and spiritual health, providing the foundation needed to walk away from darkness and toward a vibrant, clean lifestyle.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}